// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import { i18n } from './plugins/i18n.js'

// used for collapsible panel
import VueCollapse from 'vue2-collapse';
import VueExcelXlsx from "vue-excel-xlsx";

import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
window.$ = require('jquery');

import 'enjoyhint/jquery.enjoyhint.js'
import 'enjoyhint/enjoyhint.css'
// import 'jquery.scrollto/jquery.scrollTo.js'

import App from './App'
import io from 'socket.io-client';
window.io = io;

import request from '@/services/request'
window.request = request;

import store from './services/store'
import router from './router'
var lang = (store.state.config.generalSettings) ? store.state.config.generalSettings.language_id : (localStorage.getItem('lang')) ? localStorage.getItem('lang') : process.env.KIPAKI_locale
localStorage.setItem('lang', lang)

import '@/services/directive'

import helper from '@/services/helper'
window.helper = helper;

import './registerServiceWorker'
const VueInputMask = require('vue-inputmask').default
const EnjoyHint = require('enjoyhint')

Vue.use(VueInputMask);
Vue.use(EnjoyHint);
Vue.use(VueCollapse);
Vue.use(VueExcelXlsx);
Vue.use(ElementUI, {
    locale
});
Vue.config.productionTip = false

global.serverBus = new Vue();

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    i18n,
    store,
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js